import { FC, Fragment, useCallback, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDidMount } from "rooks";
import TabContext from "@mui/lab/TabContext";
import { TabPanel } from "@mui/lab";
import Stack from "@mui/material/Stack";
import { AzureReservedInstanceDrawerContentHeaderInfoCards } from "./AzureReservedInstanceDrawerContentHeaderInfoCards";
import { AzureReservedInstanceDrawerChartHeader } from "./AzureReservedInstanceDrawerChartHeader";
import { CommitmentsDrawerHeader } from "../../../../../common/components/drawer/header/CommitmentsDrawerHeader";
import { AzureReservedInstanceDrawerChart } from "../common/AzureReservedInstanceDrawerChart";
import { AzureReservationDrawerDataGrid } from "../common/data-grid/AzureReservationDrawerDataGrid";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsDetailsDrawerTargetIdSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetIdSelector";
import { getAzureReservationDetailsThunk } from "@/store/commitments/thunks/azure/reservations/getAzureReservationDetailsThunk";
import { CommitmentDrawerTabs } from "@/components/pages/commtiments/common/components/drawer/CommitmentDrawerTabs";
import { CommitmentDrawerTabType } from "@/components/pages/commtiments/common/components/drawer/utils/constants";

interface AzureReservedInstanceDrawerContentProps {
  onClose(): void;
}

export const AzureReservedInstanceDrawerContent: FC<
  AzureReservedInstanceDrawerContentProps
> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const [tab, setTab] = useState("utilization");

  const targetId = useAppSelector(commitmentsDetailsDrawerTargetIdSelector);

  const tabChangeHandler = useCallback((tab: CommitmentDrawerTabType) => {
    setTab(tab);
  }, []);
  const tabs = useMemo(() => {
    return [
      {
        value: "utilization",
        label: (
          <Typography variant="body2" fontWeight="medium">
            Utilization
          </Typography>
        ),
      },
    ];
  }, []);
  useDidMount(() => {
    dispatch(getAzureReservationDetailsThunk());
  });

  return (
    <Fragment>
      <CommitmentsDrawerHeader
        label="Reservation:"
        title={targetId}
        onClose={onClose}
      >
        <AzureReservedInstanceDrawerContentHeaderInfoCards />
      </CommitmentsDrawerHeader>

      <Box bgcolor="grey.50" height="100%">
        <TabContext value={tab}>
          <CommitmentDrawerTabs onTabChange={tabChangeHandler} tabs={tabs} />
          <TabPanel value="utilization" sx={{ p: 0, flex: 1 }}>
            <Stack px={0.5} bgcolor="white">
              <AzureReservedInstanceDrawerChart
                ChartHeader={AzureReservedInstanceDrawerChartHeader}
                type="utilization"
              />

              <AzureReservationDrawerDataGrid viewTab="commitment" />
            </Stack>
          </TabPanel>
        </TabContext>
      </Box>
    </Fragment>
  );
};
